import { render } from "./GroupsSection.vue?vue&type=template&id=674d2426&scoped=true"
import script from "./GroupsSection.vue?vue&type=script&lang=js"
export * from "./GroupsSection.vue?vue&type=script&lang=js"

import "./GroupsSection.vue?vue&type=style&index=0&id=674d2426&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674d2426"]])

export default __exports__